module.exports = __webpack_public_path__ + "img/download.10389279.svg";